import { EcCountry } from './country';
import { Horaire } from './horaire';
import { EbEtablissement } from './etablissement';
import { EbCompagnie } from './compagnie';
import { EbUser } from './user';
export class EbAdresse {

  ebAdresseNum: number;
  reference: String;
  city: String;
  phone: String;
  airport: String;
  country: EcCountry;
  zipCode: String;
  email : String
  street: String;
  company: String;
  type: number;
  dateAjout: Date;
  openingHours : Horaire;
  openingHoursFreeText: String;
  etablissement : EbEtablissement;
  ebCompagnie : EbCompagnie;
  createdBy : EbUser;
  commentaire: String;
  isEtablissement: boolean;

  constructor() {
    this.ebAdresseNum = null;
    this.reference = null;
    this.city = null;
    this.phone = null;
    this.airport = null;
    this.country = null;
    this.zipCode = null;
    this.email = null;
    this.street = null;
    this.company = null;
    this.type = null;
    this.dateAjout = null;
    this.openingHours = new Horaire();
    this.openingHoursFreeText = null;
    this.etablissement = null;
    this.ebCompagnie = null;
    this.createdBy = null;
    this.commentaire = null;
    this.isEtablissement = false;
  }

  constructorCopy(adresse: EbAdresse) {
    this.ebAdresseNum = adresse.ebAdresseNum;
    this.reference = adresse.reference;
    this.city = adresse.city;
    this.phone = adresse.phone;
    this.airport = adresse.airport;
    if (adresse.country !== null) {
      this.country = new EcCountry();
      this.country.constructorCopy(adresse.country);
    }
    else this.country = null;
    this.zipCode = adresse.zipCode;
    this.email = adresse.email;
    this.street = adresse.street;
    this.company = adresse.company;
    this.type = adresse.type;
    this.dateAjout = adresse.dateAjout;
    this.openingHoursCopy(adresse);
    this.openingHoursFreeText = adresse.openingHoursFreeText;
    this.commentaire = adresse.commentaire;
    this.isEtablissement = adresse.isEtablissement;
    if(adresse.etablissement != null)
    {
        var etablissementChecked : any = adresse.etablissement;
        if(!isNaN(etablissementChecked)) {
            var newEb = new EbEtablissement();
            newEb.ebEtablissementNum = etablissementChecked;
            adresse.etablissement = newEb;
            this.etablissement = adresse.etablissement;
        }
        else {
            adresse.etablissement.adresse = null;
            this.etablissement = adresse.etablissement;
        }
    }
    if(adresse.ebCompagnie){
        this.ebCompagnie = new EbCompagnie();
        this.ebCompagnie.ebCompagnieNum = adresse.ebCompagnie.ebCompagnieNum;
    }
    if(adresse.createdBy){
        this.createdBy = new EbUser();
        this.createdBy.ebUserNum = adresse.createdBy.ebUserNum;
    }
  }

  openingHoursCopy(adresse: EbAdresse) {
    if (adresse.openingHours === undefined || adresse.openingHours === null) {
        this.openingHours = new Horaire();
    }
    else {
        this.openingHours.constructorCopy(adresse.openingHours);
        this.openingHours.jours.sort((obj1, obj2) => {
            if (obj1.jourEnum.code > obj2.jourEnum.code) {
                return 1;
            }

            if (obj1.jourEnum.code < obj2.jourEnum.code) {
                return -1;
            }

            return 0;
        });
    }
}

}




// WEBPACK FOOTER //
// ./src/app/classes/adresse.ts